import React from 'react'
import PropTypes from 'prop-types'

const filterOutFromObject = (obj, keysToFilterOut) =>
  Object.keys(obj)
    .filter(key => !keysToFilterOut.includes(key))
    .reduce((newObj, key) => Object.assign(newObj, { [key]: obj[key] }), {})

const filterOutSrc = obj => filterOutFromObject(obj, 'src')

const addIconFontClass = props =>
  `nm-icon-${props.iconName} ${props.className ? props.className : ''}`

export const StickyToBottomContainer = props =>
  <div className={`sticky-to-bottom ${props.className}`}>
    {props.children}
  </div>

export const FontIcon = props =>
  <i
    style={props.size ? { fontSize: props.size + 'px', display: 'flex' } : {}}
    className={`${addIconFontClass(props)}`}
  />

export const SvgIcon = props =>
  <img
    style={props.size ? { height: props.size + 'px' } : {}}
    src={require(`../../../common_assets/images/${props.iconName.slice(
      0,
      -'.embedded'.length
    )}.embedded.svg`)}
    className={props.className}
  />

export const Icon = props =>
  props.iconName.endsWith('.embedded') ? <SvgIcon {...props} /> : <FontIcon {...props} />

export const IconWithLink = props =>
  <a
    data-analytics-event-category={props['data-analytics-event-category']}
    data-analytics-event-action={props['data-analytics-event-action']}
    data-analytics-event-label={props['data-analytics-event-label']}
    style={props.size ? { fontSize: props.size + 'px' } : {}}
    href={props.href}
    className={addIconFontClass(props)}
  />

Icon.propTypes = {
  children: PropTypes.string,
}

export const Text = props =>
  <div {...props} className={`mm-ellipsis ${props.className ? props.className : ''}`} />

Text.propTypes = {
  children: PropTypes.string,
}

export const MenuItem = props =>
  <div className="menu-item">
    {props.children}
  </div>

export const HBox = props =>
  <div {...props} className={`hbox ${props.className ? props.className : ''}`} />

export const LinkWithImage = props =>
  <a {...filterOutSrc(props)}>
    <img src={props.src} />
  </a>

export const Link = props =>
  <a {...props} className={`mm-ellipsis ${props.className ? props.className : ''}`} />



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/menu/primitives.components.js